module.exports = __webpack_public_path__ + "img/philipe.1905f257.webp";